import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=15dd1d45&scoped=true&"
import script from "./TemplateEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEdit.vue?vue&type=style&index=0&id=15dd1d45&lang=scss&"
import style1 from "./TemplateEdit.vue?vue&type=style&index=1&id=15dd1d45&lang=scss&"
import style2 from "./TemplateEdit.vue?vue&type=style&index=2&id=15dd1d45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd1d45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15dd1d45')) {
      api.createRecord('15dd1d45', component.options)
    } else {
      api.reload('15dd1d45', component.options)
    }
    module.hot.accept("./TemplateEdit.vue?vue&type=template&id=15dd1d45&scoped=true&", function () {
      api.rerender('15dd1d45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/services/template/TemplateEdit.vue"
export default component.exports